var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-content account" }, [
    _vm.personalDataAdditionalUploadNeeded &&
    !_vm.mobileNumberAdditionalUploadNeeded
      ? _c("div", [
          _c("h1", [
            _vm._v(
              _vm._s(_vm.$t("Account.Verification.Aristotle.Verify.Title"))
            )
          ]),
          _vm._v(" "),
          _c("p", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("Account.Verification.Aristotle.Verify.Info")
              )
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.mobileNumberAdditionalUploadNeeded &&
    !_vm.personalDataAdditionalUploadNeeded
      ? _c("div", [
          _c("h1", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "Account.Verification.Customer.MobileNumberOwnership.Verify.Title"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("p", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t(
                  "Account.Verification.Customer.MobileNumberOwnership.Verify.Info"
                )
              )
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.personalDataAdditionalUploadNeeded &&
    _vm.mobileNumberAdditionalUploadNeeded
      ? _c("div", [
          _c("h1", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "Account.Verification.Customer.IdAndMobileNumberOwnership.Verify.Title"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("p", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t(
                  "Account.Verification.Customer.IdAndMobileNumberOwnership.Verify.Info"
                )
              )
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.personalDataAdditionalUploadNeeded
      ? _c("div", [
          _c("div", [
            _c("span", {
              staticClass: "list-title",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("Account.Verification.Aristotle.Verify.ListA.Title")
                )
              }
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "list-info",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("Account.Verification.Aristotle.Verify.ListA.Info")
                )
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "control-block" }, [
              _c(
                "ul",
                _vm._l(_vm.imageTypesListA, function(item) {
                  return _c("li", [
                    _vm._v(
                      "\n            " + _vm._s(item.Text) + "\n          "
                    )
                  ])
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", [
            _c("span", {
              staticClass: "list-title",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("Account.Verification.Aristotle.Verify.ListB.Title")
                )
              }
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "list-info",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("Account.Verification.Aristotle.Verify.ListB.Info")
                )
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "control-block" }, [
              _c(
                "ul",
                _vm._l(_vm.imageTypesListB, function(item) {
                  return _c("li", [
                    _vm._v(
                      "\n            " + _vm._s(item.Text) + "\n          "
                    )
                  ])
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", [
            _c("span", {
              staticClass: "list-title",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("Account.Verification.Aristotle.Verify.ListC.Title")
                )
              }
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "list-info",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("Account.Verification.Aristotle.Verify.ListC.Info")
                )
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "control-block" }, [
              _c(
                "ul",
                _vm._l(_vm.imageTypesListC, function(item) {
                  return _c("li", [
                    _vm._v(
                      "\n            " + _vm._s(item.Text) + "\n          "
                    )
                  ])
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("br")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.mobileNumberAdditionalUploadNeeded
      ? _c("div", [
          _vm.imageTypesListD && _vm.imageTypesListD.length > 0
            ? _c("div", [
                _c("span", {
                  staticClass: "list-title",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "Account.Verification.Aristotle.Verify.ListD.Title"
                      )
                    )
                  }
                }),
                _vm._v(" "),
                _c("p", {
                  staticClass: "list-info",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("Account.Verification.Aristotle.Verify.ListD.Info")
                    )
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "control-block" }, [
                  _c(
                    "ul",
                    _vm._l(_vm.imageTypesListD, function(item) {
                      return _c("li", [
                        _vm._v(
                          "\n            " + _vm._s(item.Text) + "\n          "
                        )
                      ])
                    }),
                    0
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("br")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("p", {
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("Account.Verification.Aristotle.Verify.Upload.Info", {
            extList: _vm.allowedExt()
          })
        )
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pd verify ctsform upload-doc-form" },
      [
        _c("form", [
          _vm.personalDataAdditionalUploadNeeded
            ? _c("div", [
                _c("div", { staticClass: "pd-verify" }, [
                  _c("h2", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Account.Verification.Aristotle.Verify.ListA")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "control-block cs",
                      class: { filled: _vm.imageTypeA }
                    },
                    [
                      _c("v-select", {
                        staticClass: "custom-select",
                        attrs: {
                          "menu-props": { contentClass: "select_list" },
                          id: "imageTypeA",
                          items: _vm.imageTypesListAOptions,
                          label: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.changedImageType(_vm.imageTypeA, "a")
                          }
                        },
                        model: {
                          value: _vm.imageTypeA,
                          callback: function($$v) {
                            _vm.imageTypeA = $$v
                          },
                          expression: "imageTypeA"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.Verification.Aristotle.Verify.IdentificationType"
                            )
                          )
                        ),
                        _c("span", { staticClass: "control-label-required" }, [
                          _vm._v(" *")
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "control-block" }, [
                    _vm.fileASizeMax
                      ? _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Verification.Aristotle.Verify.Upload.MaxSize",
                                { order: 1, size: _vm.fileASizeMax }
                              )
                            )
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "control-block" }, [
                    _c(
                      "label",
                      {
                        class: {
                          "input-file-disabled": !_vm.imageTypeA,
                          "input-file": _vm.imageTypeA
                        },
                        attrs: { id: "qa-choose-file-a" }
                      },
                      [
                        _c("input", {
                          ref: "inputA",
                          staticStyle: { display: "none" },
                          attrs: {
                            type: "file",
                            disabled: !_vm.imageTypeA,
                            name: "listA"
                          },
                          on: { change: _vm.onFileASelected }
                        }),
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.Verification.Aristotle.Verify.Upload.ChooseFile"
                            )
                          ) + "\n            "
                        )
                      ]
                    ),
                    _vm._v(" \n            "),
                    _vm.fileAName
                      ? _c("span", [_vm._v(_vm._s(_vm.fileAName))])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.errorMessages.imageAMissing
                      ? _c("div", {
                          staticClass: "vmsg invalid",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Verification.Aristotle.Upload.MissingFile",
                                {
                                  typeId: _vm.getSelectedIdentificationTypeText(
                                    _vm.imageTypeA
                                  )
                                }
                              )
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorMessages.imageASize
                      ? _c("div", {
                          staticClass: "vmsg invalid",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Verification.Aristotle.Upload.InvalidSize",
                                { size: _vm.fileASizeMax }
                              )
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorMessages.imageAExtension
                      ? _c("div", {
                          staticClass: "vmsg invalid",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Verification.Aristotle.Upload.InvalidExtension",
                                { extList: _vm.allowedExt() }
                              )
                            )
                          }
                        })
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pd-verify" }, [
                  _c("h2", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Account.Verification.Aristotle.Verify.ListB")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "control-block cs",
                      class: { filled: _vm.imageTypeB }
                    },
                    [
                      _c("v-select", {
                        staticClass: "custom-select",
                        attrs: {
                          "menu-props": { contentClass: "select_list" },
                          id: "imageTypeB",
                          items: _vm.imageTypesListBOptions,
                          label: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.changedImageType(_vm.imageTypeB, "b")
                          }
                        },
                        model: {
                          value: _vm.imageTypeB,
                          callback: function($$v) {
                            _vm.imageTypeB = $$v
                          },
                          expression: "imageTypeB"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.Verification.Aristotle.Verify.IdentificationType"
                            )
                          )
                        ),
                        _c("span", { staticClass: "control-label-required" }, [
                          _vm._v(" *")
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "control-block" }, [
                    _vm.fileBSizeMax
                      ? _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Verification.Aristotle.Verify.Upload.MaxSize",
                                { order: 2, size: _vm.fileBSizeMax }
                              )
                            )
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "control-block" }, [
                    _c(
                      "label",
                      {
                        class: {
                          "input-file-disabled": !_vm.imageTypeB,
                          "input-file": _vm.imageTypeB
                        },
                        attrs: { id: "qa-choose-file-b" }
                      },
                      [
                        _c("input", {
                          ref: "inputB",
                          staticStyle: { display: "none" },
                          attrs: {
                            type: "file",
                            disabled: !_vm.imageTypeB,
                            name: "listB"
                          },
                          on: { change: _vm.onFileBSelected }
                        }),
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.Verification.Aristotle.Verify.Upload.ChooseFile"
                            )
                          ) + "\n            "
                        )
                      ]
                    ),
                    _vm._v(" \n            "),
                    _vm.fileBName
                      ? _c("span", [_vm._v(_vm._s(_vm.fileBName))])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.errorMessages.imageBMissing
                      ? _c("div", {
                          staticClass: "vmsg invalid",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Verification.Aristotle.Upload.MissingFile",
                                {
                                  typeId: _vm.getSelectedIdentificationTypeText(
                                    _vm.imageTypeB
                                  )
                                }
                              )
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorMessages.imageBSize
                      ? _c("div", {
                          staticClass: "vmsg invalid",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Verification.Aristotle.Upload.InvalidSize",
                                { size: _vm.fileBSizeMax }
                              )
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorMessages.imageBExtension
                      ? _c("div", {
                          staticClass: "vmsg invalid",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Verification.Aristotle.Upload.InvalidExtension",
                                { extList: _vm.allowedExt() }
                              )
                            )
                          }
                        })
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pd-verify" }, [
                  _c("h2", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Account.Verification.Aristotle.Verify.ListC")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "control-block cs",
                      class: { filled: _vm.imageTypeC }
                    },
                    [
                      _c("v-select", {
                        staticClass: "custom-select",
                        attrs: {
                          "menu-props": { contentClass: "select_list" },
                          id: "imageTypeC",
                          items: _vm.imageTypesListCOptions,
                          label: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.changedImageType(_vm.imageTypeC, "c")
                          }
                        },
                        model: {
                          value: _vm.imageTypeC,
                          callback: function($$v) {
                            _vm.imageTypeC = $$v
                          },
                          expression: "imageTypeC"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.Verification.Aristotle.Verify.IdentificationType"
                            )
                          )
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "control-block" }, [
                    _vm.fileCSizeMax
                      ? _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Verification.Aristotle.Verify.Upload.MaxSize",
                                { order: 3, size: _vm.fileCSizeMax }
                              )
                            )
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "control-block" }, [
                    _c(
                      "label",
                      {
                        class: {
                          "input-file-disabled": !_vm.imageTypeC,
                          "input-file": _vm.imageTypeC
                        },
                        attrs: { id: "qa-choose-file-c" }
                      },
                      [
                        _c("input", {
                          ref: "inputC",
                          staticStyle: { display: "none" },
                          attrs: {
                            type: "file",
                            disabled: !_vm.imageTypeC,
                            name: "listC"
                          },
                          on: { change: _vm.onFileCSelected }
                        }),
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.Verification.Aristotle.Verify.Upload.ChooseFile"
                            )
                          ) + "\n            "
                        )
                      ]
                    ),
                    _vm._v(" \n            "),
                    _vm.fileCName
                      ? _c("span", [_vm._v(_vm._s(_vm.fileCName))])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.errorMessages.imageCMissing
                      ? _c("div", {
                          staticClass: "vmsg invalid",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Verification.Aristotle.Upload.MissingFile",
                                {
                                  typeId: _vm.getSelectedIdentificationTypeText(
                                    _vm.imageTypeC
                                  )
                                }
                              )
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorMessages.imageCSize
                      ? _c("div", {
                          staticClass: "vmsg invalid",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Verification.Aristotle.Upload.InvalidSize",
                                { size: _vm.fileCSizeMax }
                              )
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorMessages.imageCExtension
                      ? _c("div", {
                          staticClass: "vmsg invalid",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Verification.Aristotle.Upload.InvalidExtension",
                                { extList: _vm.allowedExt() }
                              )
                            )
                          }
                        })
                      : _vm._e()
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.mobileNumberAdditionalUploadNeeded
            ? _c("div", [
                _vm.imageTypesListD && _vm.imageTypesListD.length > 0
                  ? _c("div", { staticClass: "pd-verify" }, [
                      _c("h2", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.Verification.Aristotle.Verify.ListD"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "control-block cs",
                          class: { filled: _vm.imageTypeD }
                        },
                        [
                          _c("v-select", {
                            staticClass: "custom-select",
                            attrs: {
                              "menu-props": { contentClass: "select_list" },
                              id: "imageTypeD",
                              items: _vm.imageTypesListDOptions,
                              label: ""
                            },
                            on: {
                              change: function($event) {
                                return _vm.changedImageType(_vm.imageTypeD, "d")
                              }
                            },
                            model: {
                              value: _vm.imageTypeD,
                              callback: function($$v) {
                                _vm.imageTypeD = $$v
                              },
                              expression: "imageTypeD"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { staticClass: "control-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.Verification.Aristotle.Verify.IdentificationType"
                                )
                              )
                            ),
                            _c(
                              "span",
                              { staticClass: "control-label-required" },
                              [_vm._v(" *")]
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "control-block" }, [
                        _vm.fileDSizeMax
                          ? _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "Account.Verification.Aristotle.Verify.Upload.MaxSize",
                                    { order: 4, size: _vm.fileDSizeMax }
                                  )
                                )
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "control-block" }, [
                        _c(
                          "label",
                          {
                            class: {
                              "input-file-disabled": !_vm.imageTypeD,
                              "input-file": _vm.imageTypeD
                            },
                            attrs: { id: "qa-choose-file-d" }
                          },
                          [
                            _c("input", {
                              ref: "inputD",
                              staticStyle: { display: "none" },
                              attrs: {
                                type: "file",
                                disabled: !_vm.imageTypeD,
                                name: "listD"
                              },
                              on: { change: _vm.onFileDSelected }
                            }),
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.Verification.Aristotle.Verify.Upload.ChooseFile"
                                )
                              ) + "\n            "
                            )
                          ]
                        ),
                        _vm._v(" \n            "),
                        _vm.fileDName
                          ? _c("span", [_vm._v(_vm._s(_vm.fileDName))])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm.errorMessages.imageDMissing
                          ? _c("div", {
                              staticClass: "vmsg invalid",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "Account.Verification.Aristotle.Upload.MissingFile",
                                    {
                                      typeId: _vm.getSelectedIdentificationTypeText(
                                        _vm.imageTypeD
                                      )
                                    }
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errorMessages.imageDSize
                          ? _c("div", {
                              staticClass: "vmsg invalid",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "Account.Verification.Aristotle.Upload.InvalidSize",
                                    { size: _vm.fileDSizeMax }
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errorMessages.imageDExtension
                          ? _c("div", {
                              staticClass: "vmsg invalid",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "Account.Verification.Aristotle.Upload.InvalidExtension",
                                    { extList: _vm.allowedExt() }
                                  )
                                )
                              }
                            })
                          : _vm._e()
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "success",
                    "x-large": "",
                    disabled: _vm.isDisabled()
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.onUpload.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Account.Verification.Aristotle.Verify.Upload")
                      )
                    )
                  ])
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "ProcessingDialog",
          {
            attrs: {
              isDialogPersistent: true,
              isProcessing: _vm.isProcessing,
              isSuccess: !_vm.transactionError,
              processingTitle: _vm.$t(
                "Account.Verification.Aristotle.Upload.Dialog.Processing.Title"
              ),
              processingText: _vm.$t(
                "Account.Verification.Aristotle.Upload.Dialog.Processing.Text"
              ),
              successTitle: _vm.$t(
                "Account.Verification.Aristotle.Upload.Dialog.Success.Title"
              ),
              successText: _vm.$t(
                "Account.Verification.Aristotle.Upload.Dialog.Success.Text"
              ),
              errorTitle: _vm.$t(
                "Account.Verification.Aristotle.Upload.Dialog.Error.Title"
              ),
              closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
            },
            on: { close: _vm.closeVerificationDialog },
            model: {
              value: _vm.dialog,
              callback: function($$v) {
                _vm.dialog = $$v
              },
              expression: "dialog"
            }
          },
          [
            _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
              _vm.brandKey !== "sb"
                ? _c(
                    "p",
                    { staticClass: "generic-icon-note" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { color: "error" } },
                        [_vm._v("error")]
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.Verification.Aristotle.Upload.Dialog.Error.Text"
                            )
                          )
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("p", { staticClass: "response-error" }, [
                _vm._v(_vm._s(_vm.transactionError))
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t(
                      "Account.Verification.Aristotle.Upload.Dialog.Error.Text.ContactSupport"
                    )
                  )
                }
              })
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b6d4df4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b6d4df4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/IntegratedWallet/VerificationPersonalData.vue
// module id = null
// module chunks = 